<template>
<div class="w-full my-4 flex items-center bg-white rounded-lg py-2 relative hover:shadow transition-shadow transition-100" :class="{'opacity-60': promotionsAreChecking}">
  <div v-if="promotionsAreChecking" class="cart-preview-preloader absolute">
    <i class="fad fa-spinner-third fa-spin text-3xl"></i>
  </div>
  <div class="w-20 mr-2">
    <div class="text-center">
      <i class="fad fa-gift text-primary-darker text-5xl"></i>
    </div>
  </div>
  <div class="mx-1 flex-grow py-2">
    <router-link :to="route">
      <h4 class="font-normal text-sm mb-2">{{ title }}</h4>
      <p class="font-light mb-0 text-xs opacity-60">Перейдите на страницу выбора для просмотра доступных подарков.</p>
    </router-link>
  </div>
  <div class="self-stretch text-center flex-grow flex justify-end order-10">
    <router-link :to="route" class="btn btn-primary btn-sm btn-rounded mr-4 height-fit-content self-center">
      Выбрать
    </router-link>
  </div>
</div>
</template>

<script>
import pluralize from '@/helpers/pluralize'
import { mapGetters } from 'vuex'

export default {
  props: {
    promotionId: {
      required: true,
      type: String,
    },

    rewardId: {
      required: true,
      type: String,
    },

    context: {
      required: false,
      type: Object,
      default: null,
    },

    maxQuantity: {
      required: false,
      type: Number,
      default: null,
    },
  },

  computed: {
    ...mapGetters({
      promotionsAreChecking: 'order/promotionsAreChecking',
    }),

    route() {
      const query = {}

      if (this.context) {
        query.context_type = this.context.type
        query.context_id = this.context.id
      }

      return {
        query,
        name: 'promotions.rewards',
        params: {
          promotionId: this.promotionId,
          rewardId: this.rewardId,
        },
      }
    },

    title() {
      return pluralize(this.maxQuantity, [
          `Вам доступен ${this.maxQuantity} подарок`,
          `Вам доступно ${this.maxQuantity} подарка`,
          `Вам доступно ${this.maxQuantity} подарков`,
      ], false)
    },
  },
}
</script>
